.display-field--url {
    min-width: 0;
    max-width: 100%;
}

.content-text {
    text-align: inherit;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

td .content-text {
    white-space: unset;
    /* Как в заголовке столбца: перенос по словам, а не по буквам. overflow-wrap:
       anywhere уменьшает min-content до одного символа и в узких колонках грида
       выстраивает текст побуквенно в столбик — normal оставляет слова целыми. */
    overflow-wrap: normal;
}

.table-cell .content-text {
    white-space: unset;
    overflow-wrap: normal;
}

td .content-text.trim-long-text {
    white-space: pre-wrap;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: normal;
}

td .content-text.wrap {
    white-space: normal;
    word-break: normal;
}

td .content-text.no-wrap {
    white-space: pre-wrap;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}

.routes-table td .content-text {
    white-space: pre-wrap !important;
}
